import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { INCIDENTS_LIST } from '@/utils/constants';
import {
  SEARCH_PARAM_INCIDENT_SEARCH,
  SEARCH_PARAM_ROUTE_SEARCH,
  SEARCH_PARAMS_ROUTE_ID,
} from '@/utils/constants/queries';

const useRouteSearch = (viewType: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const prevRouteIdRef = useRef<string | null>(null);

  const paramRouteId = searchParams.get(SEARCH_PARAMS_ROUTE_ID);

  const isIncidentsView = viewType === INCIDENTS_LIST;
  const activeParam = isIncidentsView ? SEARCH_PARAM_INCIDENT_SEARCH : SEARCH_PARAM_ROUTE_SEARCH;
  const activeSearchKey = searchParams.get(activeParam) ?? '';

  const setActiveSearchKey = (value: string) => {
    const current = searchParams.get(activeParam) ?? '';

    if (value === current) {
      return;
    }

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);

        if (value) {
          next.set(activeParam, value);
        } else {
          if (isIncidentsView) {
            next.delete(SEARCH_PARAM_INCIDENT_SEARCH);
          } else {
            next.delete(SEARCH_PARAM_ROUTE_SEARCH);
            next.delete(SEARCH_PARAM_INCIDENT_SEARCH);
          }
        }

        return next;
      },
      { replace: true }
    );
  };

  useEffect(() => {
    if (!paramRouteId) {
      return;
    }

    if (paramRouteId === prevRouteIdRef.current) {
      return;
    }

    prevRouteIdRef.current = paramRouteId;

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(SEARCH_PARAM_INCIDENT_SEARCH);

        return next;
      },
      { replace: true }
    );
  }, [paramRouteId]);

  return { activeSearchKey, setActiveSearchKey };
};

export default useRouteSearch;
